export const IMPORT_MAX_ROWS = 1000;

export const IMPORT_ENTITY_TYPES = [
  "unlisted",
  "non_profit",
  "listed",
  "public_autority",
  "person",
] as const;

export type ImportEntityType = (typeof IMPORT_ENTITY_TYPES)[number];

export type AssignmentMode = "with" | "without";

export type ImportRowStatus = "pending" | "created" | "existing" | "error";

export type ImportFileError =
  | "empty"
  | "missing_columns"
  | "missing_assignment"
  | "unexpected_assignment"
  | "too_many_rows";

export type ImportMessageCode =
  | "siren_invalid"
  | "entity_type_invalid"
  | "id_owner_too_long"
  | "duplicate_siren"
  | "external_mismatch"
  | "auto_failed"
  | "folder_failed"
  | "ereputation_failed"
  | "follow_failed"
  | "api_error";

export type ImportRow = {
  lineNumber: number;
  siren: string;
  idOwner: string | null;
  entityType: string;
  assigneeIds: string[];
  isValid: boolean;
  duplicate: boolean;
  status: ImportRowStatus;
  existant: boolean | null;
  creationAuto: boolean | null;
  creationFolder: boolean | null;
  callEReputation: boolean | null;
  callFollowFolder: boolean | null;
  messageCodes: ImportMessageCode[];
  messageDetail: string | null;
  processedOrder: number | null;
  customerFolderId: string | null;
  folderFileId: string | null;
};

export type ParsedImportFile = {
  fileError: ImportFileError | null;
  rows: ImportRow[];
};

export type ImportStats = {
  total: number;
  created: number;
  existing: number;
  error: number;
  createdPct: number;
  existingPct: number;
  errorPct: number;
};

export const EXTERNAL_DATA_MISMATCH = "External data do not correspond to operation type";

export class ExternalDataMismatchError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ExternalDataMismatchError";
  }
}

export const isExternalDataMismatch = (message: string) => message.includes(EXTERNAL_DATA_MISMATCH);
